const layout = {
  // Height of the search/dial toolbar above every page
  topbarHeight: "56px",
  sidebarWidth: "220px",
};

export default layout;
